import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { ChipButton, Typography } from 'seagull';
import { DropdownMenu } from 'seagull/components/DropdownMenu';
import { Archive, ChevronDown, ChevronUp, Trash } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import styles from './ClientsBulkActions.module.scss';
export const GetClientsBulkActionsTID = (parentTestId)=>getTestIds(parentTestId);
export function ClientsBulkActions(param) {
    let { numSelected, testId, onBulkArchive, onBulkDelete } = param;
    const { t: bulkTexts } = useLocaleKeys('pages.clientsDashboard.bulkActions');
    const { ClientsBulkActionsTestIds: TID } = useMemo(()=>GetClientsBulkActionsTID(testId), [
        testId
    ]);
    const [isOpen, setIsOpen] = useState(false);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                className: styles.selectedItems,
                testId: TID.Counter(),
                children: numSelected > 0 ? bulkTexts.selectedCount({
                    count: numSelected
                }) : ''
            }),
            /*#__PURE__*/ _jsxs(DropdownMenu, {
                onOpenChange: setIsOpen,
                target: /*#__PURE__*/ _jsx(ChipButton, {
                    bi: {
                        name: 'clients_bulk_actions'
                    },
                    testId: TID.Root(),
                    suffixIcon: isOpen ? /*#__PURE__*/ _jsx(ChevronUp, {}) : /*#__PURE__*/ _jsx(ChevronDown, {}),
                    highlight: isOpen,
                    disabled: numSelected === 0,
                    children: bulkTexts.label()
                }),
                children: [
                    /*#__PURE__*/ _jsx(DropdownMenu.Item, {
                        bi: {
                            name: 'clients_bulk_archive'
                        },
                        iconStart: /*#__PURE__*/ _jsx(Archive, {}),
                        testId: TID.Archive(),
                        onClick: onBulkArchive,
                        children: bulkTexts.archive()
                    }),
                    /*#__PURE__*/ _jsx(DropdownMenu.Item, {
                        bi: {
                            name: 'clients_bulk_delete'
                        },
                        iconStart: /*#__PURE__*/ _jsx(Trash, {
                            size: 20
                        }),
                        testId: TID.Delete(),
                        skin: "error",
                        onClick: onBulkDelete,
                        children: bulkTexts.delete()
                    })
                ]
            })
        ]
    });
}
